// extracted by mini-css-extract-plugin
export default {"root":"GoalTeam__root","concierge":"GoalTeam__concierge","checkboxWrapper":"GoalTeam__checkboxWrapper lightBrandColor__bg","modalContent":"GoalTeam__modalContent brandColor__bg"};